import React from "react";
import PropTypes from "prop-types";

const Note = ({ value }) => (
  <p className="text-grey-darker-1 text-12 my-2">{value}</p>
);

Note.propTypes = {
  value: PropTypes.string
};

export default Note;
